var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScratchedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#123766"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3059 18.0002H28.7198M28.7198 18.0002L25.9267 20.7933M28.7198 18.0002L25.9267 15.207",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8232 14.5863V10C22.8232 9.44772 22.3755 9 21.8232 9H12.03C11.4777 9 11.03 9.44772 11.03 10V26.0002C11.03 26.5525 11.4777 27.0002 12.03 27.0002H21.8232C22.3755 27.0002 22.8232 26.5525 22.8232 26.0002V21.4139",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratchedIcon);
export default __webpack_public_path__ + "static/media/scratchedIcon.d3d22c855d30ada1f25fc6591c8277ff.svg";
export { ForwardRef as ReactComponent };